import { makeAnalyticsComposite } from '~/composables/analytics/factories/analytics-composite-factory'

export default (context, inject) => {
  if (typeof window === 'undefined') {
    return
  }

  const analytics = makeAnalyticsComposite()

  inject('analytics', analytics)
  window.$analytics = analytics
}
